import { useState } from "react";
import { Outlet } from "react-router-dom";
import {
  OverlayDrawer,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
} from "@fluentui/react-components";
import { UsecaseOverviewButton } from "../../features/top-bar/UsecaseOverviewButton/UsecaseOverviewButton";
import styles from "./Layout.module.css";
import { useLogin } from "../../utils/authConfig";
import { LogoutButton } from "../../features/top-bar/LogoutButton";
import UsecaseMenu from "../../features/top-bar/UsecaseMenu";
import UsecaseOverviewPopUp from "../../features/top-bar/UsecaseOverview/UsecaseOverview";
import { AboutPanelContent } from "../../features/top-bar/AboutPanel/AboutPanel";

export interface GenerateStreamingType {
  handleGenerationStreaming: (data: boolean) => void;
}

export interface ShowConfigPanelType {
  handleShowConfigPanel: (data: boolean) => void;
}

const Layout = () => {
  const [isConfigPanelOpen, setIsConfigPanelOpen] = useState(false);
  const [isGenerating, setIsGenerating] = useState<boolean>(false); // State to hold data from child
  const [showContentOverview, setShowContentOverview] =
    useState<boolean>(false);

  const handleGenerationStreaming = (data: boolean) => {
    setIsGenerating(data); // Update state with data from child
  };

  const handleShowConfigPanel = (data: boolean) => {
    setIsConfigPanelOpen(data);
  };

  const handleShowUsecaseOverview = (show: boolean) => {
    console.log(`change show popup state ${show}`);
    setShowContentOverview(show);
  };

  return (
    <div className={styles.layout}>
      <header className={styles.header} role="banner">
        <div className={styles.headerContainer}>
          <h3> MBChat </h3>
          <UsecaseMenu disableUseCaseButton={isGenerating} />
          <div className={styles.buttonContainer}>
            <UsecaseOverviewButton
              className={styles.commandButton}
              onClick={() => handleShowUsecaseOverview(true)}
            />
            {useLogin}
            <LogoutButton />
          </div>
        </div>
      </header>
      <OverlayDrawer
        open={isConfigPanelOpen}
        onOpenChange={(_, data) => { if (!data.open) setIsConfigPanelOpen(false); }}
        position="end"
        modalType="non-modal"
      >
        <DrawerHeader>
          <DrawerHeaderTitle>About MB Energy</DrawerHeaderTitle>
        </DrawerHeader>
        <DrawerBody>
          {useLogin && <AboutPanelContent />}
        </DrawerBody>
      </OverlayDrawer>
      {showContentOverview && (
        <UsecaseOverviewPopUp
          dismissContentOverview={() => handleShowUsecaseOverview(false)}
        />
      )}
      <Outlet context={{ handleGenerationStreaming, handleShowConfigPanel }} />
    </div>
  );
};

export default Layout;
